/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import NotificationBadge, { Effect } from 'react-notification-badge';
import EbossTransactionContainer from "./transactions/EbossTransactionContainer";
import BPLSNewTransaction from './new/container/temporary/TransactionContainer';
import BPLSReNewTransaction from './renewal/container/temporary/TransactionContainer';
import BPLSQuarterlyTransaction from './quarterly/container/temporary/TransactionContainer';
import BPLSDelinquentTransaction from './delinquent/container/temporary/TransactionContainer';
import * as actions from './actions';
import * as c from './constant';

function EBossContainer({
  match,
  pathName,
  permissions,
  transactionListCount,
  getTransactionCount,
}) {
  // TODO: create custom hooks for notification badge later
  const newApplicationCounts = _.get(transactionListCount, 'new_applications');

  const updateListCountData = useCallback(() => {
    getTransactionCount();
  }, [transactionListCount]);

  useEffect(() => {
    updateListCountData();

    // for OrdinanceRevisionDropDown: remove formData from localStorage if user exits BPLS module
    return () => {
      ['formData', 'defaultFormValue'].forEach(data =>
        localStorage.removeItem(data)
      );
    };
  }, []);

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">

              {/* dashboard e-boss */}
              <li className="nav-item position-relative">
                <Link
                  to="/bpls/eboss-application/dashboard"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('bpls/eboss-application/dashboard') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  {/* <div
                    className="position-absolute fixed-top fixed-right"
                    style={{ zIndex: '1' }}
                  >
                    <NotificationBadge
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{ height: '25px', width: '25px', top: '10px' }}
                      count={_.get(newApplicationCounts, 'NEW', 0)}
                      effect={Effect.SCALE}
                    />
                  </div> */}
                  Dashboard
                </Link>
              </li>


              <li className="nav-item position-relative">
                <Link
                  to="/bpls/eboss-application/new"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('bpls/eboss-application/new') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  <div
                    className="position-absolute fixed-top fixed-right"
                    style={{ zIndex: '1' }}
                  >
                    <NotificationBadge
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{ height: '25px', width: '25px', top: '10px', right: '7px',}}
                      count={_.get(newApplicationCounts, 'NEW', 0)}
                      effect={Effect.SCALE}
                    />
                  </div>
                  New
                </Link>
              </li>
              <li className="nav-item position-relative">
                <Link
                  to="/bpls/eboss-application/renewal"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('bpls/eboss-application/renewal') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  <div
                    className="position-absolute fixed-top fixed-right"
                    style={{ zIndex: '1' }}
                  >
                    <NotificationBadge
                      className="d-flex align-items-center justify-content-center rounded-circle"
                      style={{
                        height: '25px',
                        width: '25px',
                        top: '10px',
                        right: '7px',
                        zIndex: '1',
                      }}
                      count={_.get(newApplicationCounts, 'RENEWAL', 0)}
                      effect={Effect.SCALE}
                    />
                  </div>
                  Renewal
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/bpls/eboss-application/quarterly"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('bpls/eboss-application/quarterly') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Quarterly
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/bpls/eboss-application/delinquent"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf('bpls/eboss-application/delinquent') > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Delinquent
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/dashboard`} />}
          />
          {Acl(permissions, ['VIEW BPLS NEW']) && ( // replace with VIEW BPLS DASHBOARD
            <Route path={`${match.path}/dashboard`} component={EbossTransactionContainer} />
          )}
          {Acl(permissions, ['VIEW BPLS NEW']) && (
            <Route path={`${match.path}/new`} component={BPLSNewTransaction} />
          )}
          {Acl(permissions, ['VIEW BPLS RENEW']) && (
            <Route
              path={`${match.path}/renewal`}
              component={BPLSReNewTransaction}
            />
          )}
          {Acl(permissions, ['VIEW BPLS RENEW']) && (
            <Route
              path={`${match.path}/quarterly`}
              component={BPLSQuarterlyTransaction}
            />
          )}
          {Acl(permissions, ['VIEW BPLS RENEW']) && (
            <Route
              path={`${match.path}/delinquent`}
              component={BPLSDelinquentTransaction}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

EBossContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  transactionListCount: PropTypes.instanceOf(Object).isRequired,
  getTransactionCount: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
  transactionListCount: _.get(api, `${c.GET_TRANSACTION_COUNTS}.res`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(EBossContainer);